import { loadTemplate } from '../template/index.js';
import { renderQuestionModule, updateTotalCount } from './render.js';
import { studentQuestionStore } from './store.js';
import { handleClick } from './handlers.js';
import { fetchQuestions } from './ajax.js';
import { USER_ROLES } from './constants.js';

/**
 * Initialize question list
 */
export async function initList() {
	const container = document.getElementById('list-question');
	if (!container) return;

	// Load all necessary templates
	await Promise.all([
		loadTemplate('student-question/list-title.ejs'),
		loadTemplate('student-question/list.ejs'),
		loadTemplate('student-question/item.ejs'),
		loadTemplate('student-question/empty.ejs'),
		loadTemplate('student-question/empty-detail.ejs'),
		loadTemplate('student-question/detail.ejs'),
	]);

	// Load questions from CMS
	await refreshQuestions();

	// Initial render using the new module
	const questions = studentQuestionStore.getQuestions();
	const userRole = studentQuestionStore.getUserRole();

	renderQuestionModule({
		questions,
		userRole
	});

	updateTotalCount(questions.length);

	// Handle click events (delegation)
	container.addEventListener('click', handleClick);

	// Setup Filter
	const filterSelect = document.querySelector('select[name="questions"]');
	if (filterSelect) {
		filterSelect.addEventListener('change', (e) => {
			const status = e.target.value;
			const filtered = studentQuestionStore.getQuestionsByStatus(status);
			const totalQuestions = studentQuestionStore.getQuestions().length;
			renderQuestionModule({
				questions: filtered,
				userRole: studentQuestionStore.getUserRole(),
				totalQuestions
			});
			updateTotalCount(filtered.length);
		});
	}
}

/**
 * Load and refresh questions from CMS
 */
export async function refreshQuestions() {
	const data = await fetchQuestions();
	studentQuestionStore.setQuestions(data.questions || []);
	studentQuestionStore.setUserRole(data.user_role || USER_ROLES.STUDENT);

	const questions = studentQuestionStore.getQuestions();
	renderQuestionModule({
		questions,
		userRole: studentQuestionStore.getUserRole()
	});
	updateTotalCount(questions.length);
}
